import React, { useEffect } from "react";
import _ from "underscore";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";
import Image from "react-bootstrap/Image";
import config from "../../../config";
import Slider from "react-slick";
import { authCheck, carouselSettings, getCookie } from "../../common/utils";
import ProductVariation from "../../PDP/Columns/ProductVariation";
import {ModelProductList} from "../../common/ModelProductList";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { getForYouHomepageData, getShopifyDataFromFavoriteList } from "../../actionCreators/appAC";
import { getRecentlyViewed } from "../../actionCreators/pdpAC";
import { setForYouProducts } from "../../actionCreators/boostCommerceAC";

function createCarouselObject(shopify_favorites_list, recently_viewed_products, for_you_products_homepage, forYouProducts, user_profile) {

    const filtered_for_you_products_homepage = for_you_products_homepage && _.filter(_.sortBy(ModelProductList(for_you_products_homepage.items), "updatedAt").reverse(), (product) => { return product.availableForSale });
    const showPersonalizedRecommProducts = forYouProducts && forYouProducts.length > 0;
    const newForYouProducts = showPersonalizedRecommProducts ? forYouProducts : filtered_for_you_products_homepage;

    return {
        "For You": {
            collection: "For You",
            products: newForYouProducts,
            total_products: newForYouProducts && newForYouProducts.length,
            collection_url: showPersonalizedRecommProducts ? `${config.host_rebag}/for-you/` : `${config.host_rebag_shop}/collections/new-arrivals/?${for_you_products_homepage && for_you_products_homepage.bc_url}`
        },
        "Recently Viewed": {
            collection: "Recently Viewed",
            products: _.filter(_.sortBy(recently_viewed_products, "updatedAt").reverse(), (product) => { return product.availableForSale }),
            total_products: recently_viewed_products.length,
            collection_url: `${config.host_rebag_shop}/collections/new-arrivals?pf_st_availability_hidden=true`
        },
        "Your Favorites": {
            collection: "Your Favorites",
            products: _.filter(_.sortBy(shopify_favorites_list, "updatedAt").reverse(), (product) => { return product.availableForSale }),
            total_products: shopify_favorites_list.length,
            collection_url: `${config.host_rebag}/my-account/favorites`
        }
    };
}

const PersonalizedCarouselModule = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        if(authCheck()){
            dispatch(getShopifyDataFromFavoriteList());
            dispatch(getRecentlyViewed(true));
            dispatch(getForYouHomepageData());
            dispatch(setForYouProducts());
        }
    }, []);

    const { forYouProducts, for_you_products_homepage, recently_viewed_products, shopify_favorites_list, user_profile} = useSelector(state => ({
        for_you_products_homepage: state.appReducer.for_you_products_homepage,
        recently_viewed_products: state.shopifyReducer.recently_viewed_products,
        shopify_favorites_list: state.shopifyReducer.shopify_favorites_list,
        user_profile: state.myAccountReducer.user_profile,
        forYouProducts: state.shopifyReducer.forYouProducts,
    }));

    const slider_settings = { className: "products-carousel__cards rebag-carousel__cards" }
    const sliderSettings = carouselSettings(slider_settings);
    const personalized_collections = createCarouselObject(shopify_favorites_list, recently_viewed_products, for_you_products_homepage, forYouProducts, user_profile);
    const personalized_collections_keys = Object.keys(personalized_collections);
    const item_limit = window.innerWidth <= 768 ? 4 : 16;
    const is_b2b = getCookie('is_b2b');
    const is_wholesale_active = getCookie("is_wholesale_active");
    const show_personalized_carousel = (for_you_products_homepage && for_you_products_homepage.items.length > 0) || (shopify_favorites_list && shopify_favorites_list.length > 0) || (recently_viewed_products && recently_viewed_products.length > 0) || (forYouProducts && forYouProducts.length > 0);

    if (!show_personalized_carousel || personalized_collections_keys.length <= 0) {
        return null;
    }

    return (
        <div className="discover-carousel m-0">
            <Container fluid>
                <Row>
                    <Col>
                        <h2 className="discover-carousel__title">Your Collections</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Tabs
                            id="personalized-collections"
                            className="discover-carousel__tab-container"
                        >
                            {_.map(personalized_collections, (personalized_collection, personalized_collection_filter) => {
                                if (_.isEmpty(personalized_collection.products)) {
                                    return null;
                                }
                                const collection_name = personalized_collection.collection;
                                const shopify_url = personalized_collection.collection_url;
                                const tab_title = <span>
                                <div className="discover-carousel__tab--title">
                                    {collection_name}
                                </div>
                            </span>;
                                return (
                                    <Tab
                                        key={personalized_collection_filter}
                                        eventKey={personalized_collection_filter}
                                        title={tab_title}
                                        unmountOnExit={true}
                                        tabClassName="discover-carousel__tab"
                                    >
                                        <div className="products-carousel__cards-container products-carousel__cards-container--personalized">
                                            <Slider {...sliderSettings}>
                                                {_.first(_.map(personalized_collection.products, (product) => {
                                                    return (
                                                        <ProductVariation
                                                            key={`${personalized_collection}-${product.id}`}
                                                            product_variation={product}
                                                            is_b2b={is_b2b}
                                                            is_wholesale_active={is_wholesale_active}
                                                        />
                                                    )
                                                }), item_limit)}
                                                {personalized_collection.total_products > item_limit && collection_name === "Your Favorites" &&
                                                    <div className="discover-carousel__card discover-carousel__card--more-items">
                                                        <a
                                                            href={shopify_url}
                                                            className="discover-carousel__card-link-container"
                                                        >
                                                            <Image
                                                                alt="More Matches Available"
                                                                title="More Matches Available"
                                                                className="saved-search__more-items-icon"
                                                                src={`${config.MEDIA_URL}/img/shopping-bag-thin.svg`}
                                                            />
                                                            {collection_name !== "Your Favorites" &&
                                                                <div className="saved-search__more-items-title">
                                                                    More Matches Available
                                                                </div>
                                                            }
                                                            <div className="saved-search__more-items-link">
                                                                View All
                                                            </div>
                                                        </a>
                                                    </div>
                                                }
                                            </Slider>
                                        </div>
                                        <Button
                                            variant="lean"
                                            href={decodeURIComponent(shopify_url).replaceAll('[]', '')}
                                            className='discover-carousel__see-all-cta rbg-btn-dark'
                                        >
                                            See All
                                        </Button>
                                    </Tab>
                                )
                            })}
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default PersonalizedCarouselModule;